import { render, staticRenderFns } from "./ElectionSelection.vue?vue&type=template&id=357911e8&scoped=true&"
import script from "./ElectionSelection.vue?vue&type=script&lang=js&"
export * from "./ElectionSelection.vue?vue&type=script&lang=js&"
import style0 from "./ElectionSelection.vue?vue&type=style&index=0&id=357911e8&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "357911e8",
  null
  
)

export default component.exports